import { Route } from "react-router-dom";
import Hooks from "@pages/tools/hooks";
import CreateHooks from "@pages/tools/hooks/create-hook";
import Connections from "@pages/tools/connections";
import CreateConnection from "@pages/tools/connections/create-connection";
import Misconceptions from "@pages/tools/misconceptions";
import CreateMisconceptions from "@pages/tools/misconceptions/create-misconception";
import Summaries from "@pages/tools/summaries";
import CreateSummary from "@pages/tools/summaries/create-summary";
import Vocabularies from "@pages/tools/vocabularies";
import CreateVocabulary from "@pages/tools/vocabularies/create-vocabulary";
import TextLeveler from "@pages/tools/text-leveler";
import CreateTextLeveler from "@pages/tools/text-leveler/create-text-leveler";
import ImageGenerator from "@pages/tools/images";
import InteractiveMaterials from "@pages/tools/interactive-materials";
import CreateInteractiveMaterial from "@pages/tools/interactive-materials/create-interactive-material";
import SingleInteractiveMaterials from "@pages/tools/interactive-materials/single-interactive-material";
import EditInteractiveMaterial from "@pages/tools/interactive-materials/single-interactive-material/edit";
import StudentAnswers from "@pages/tools/interactive-materials/single-interactive-material/student-answers";
import ExitTickets from "@pages/tools/exit-tickets";
import CreateExitTicket from "@pages/tools/exit-tickets/create-exit-ticket";
import HomeworkIdeas from "@pages/tools/homework-ideas";
import CreateHomeworkIdea from "@pages/tools/homework-ideas/create-homework-idea";
import ChoiceBoards from "@pages/tools/choice-boards";
import CreateChoiceBoards from "@pages/tools/choice-boards/create-choice-boards";
import AiResistantHomeworkIdeas from "@pages/tools/ai-resistant-homework-ideas";
import CreateAiResistantHomeworkIdeas from "@pages/tools/ai-resistant-homework-ideas/create-ai-resistant-homework-ideas";
import EssentialQuestions from "@pages/tools/essential-questions";
import CreateEssentialQuestions from "@pages/tools/essential-questions/create-essential-questions";
import FormativeAssessment from "@pages/tools/formative-assessment";
import CreateFormativeAssessment from "@pages/tools/formative-assessment/create-formative-assessment";
import PerformanceTasks from "@pages/tools/performance-task";
import CreatePerformanceTask from "@pages/tools/performance-task/create-performance-task";
import ProjectBasedLearning from "@pages/tools/project-based-learning";
import CreateProjectBasedLearning from "@pages/tools/project-based-learning/create-project-based-learning";
import TransferActivity from "@pages/tools/transfer-activity";
import CreateTransferActivity from "@pages/tools/transfer-activity/create-transfer-activity";
import Rubric from "@pages/tools/rubric";
import CreateRubric from "@pages/tools/rubric/create-rubric";
import Collaborative from "@pages/tools/collaborative";
import CreateCollaborative from "@pages/tools/collaborative/create-collaborative";
import ClassroomManagement from "@pages/tools/classroom-management";
import CreateClassroomManagement from "@pages/tools/classroom-management/create-classroom-management";
import BloomsTaxonomyActivity from "@pages/tools/blooms-taxonomy-activities";
import CreateBloomsTaxonomyActivity from "@pages/tools/blooms-taxonomy-activities/create-blooms-taxonomy-activities";
import AiAssignmentDesigner from "@pages/tools/ai-assignment-designer";
import CreateAiAssignmentDesigner from "@pages/tools/ai-assignment-designer/create-ai-assignment-designer";
import CloneInteractiveMaterial from "@pages/tools/interactive-materials/single-interactive-material/clone";
import CreateAiSupportedTask from "@pages/tools/ai-supported-tasks/create-ai-supported-tasks";
import AiSupportedTasks from "@pages/tools/ai-supported-tasks";
import AiAssessmentScale from "@pages/tools/ai-assessment-scale";
import CreateAiAssessmentScale from "@pages/tools/ai-assessment-scale/create-ai-assessment-scale";
import Mindmaps from "@pages/tools/mindmap";
import AdvancedEditInteractiveMaterial from "@pages/tools/interactive-materials/single-interactive-material/advanced-edit";
import HeygenVideoGenerator from "@pages/tools/heygen-video-generator";
import CreateHeygenVideoGenerator from "@pages/tools/heygen-video-generator/create-heygen-video-generator";
import ArticleGenerator from "@pages/tools/article-generator";
import CreateArticle from "@pages/tools/article-generator/create-article";
import ArticleView from "@pages/tools/article-generator/article-view";
import MindMapView from "@pages/tools/mindmap/view";
import PronunciationAssessment from "@pages/tools/pronunciation-assessment";
import CreatePronunciationAssessment from "@pages/tools/pronunciation-assessment/create-pronunciation-assessment";
import PronunciationAssessmentDetail from "@pages/tools/pronunciation-assessment/detail";
import VisualMatching from "@pages/tools/visual-matching";
import CreateVisualMatching from "@pages/tools/visual-matching/create-visual-matching";
import VisualMatchingDetail from "@pages/tools/visual-matching/detail";
import SpokenDialogue from "@pages/tools/spoken-dialogue";
import CreateSpokenDialogue from "@pages/tools/spoken-dialogue/create-spoken-dialogue";
import DetailSpokenDialogue from "@pages/tools/spoken-dialogue/detail";
import ConversationPractice from "@pages/tools/spoken-dialogue/conversation-practice";

export const contentRoutes = [
  <Route key="hooks" path="/content/hooks" element={<Hooks />} />,
  <Route
    key="create-hook"
    path="/content/hooks/create"
    element={<CreateHooks />}
  />,
  <Route
    key="connections"
    path="/content/connections"
    element={<Connections />}
  />,
  <Route
    key="create-connection"
    path="/content/connections/create"
    element={<CreateConnection />}
  />,
  <Route
    key="misconceptions"
    path="/content/misconceptions"
    element={<Misconceptions />}
  />,
  <Route
    key="create-misconception"
    path="/content/misconceptions/create"
    element={<CreateMisconceptions />}
  />,
  <Route key="summaries" path="/content/summaries" element={<Summaries />} />,
  <Route
    key="create-summary"
    path="/content/summaries/create"
    element={<CreateSummary />}
  />,
  <Route
    key="vocabularies"
    path="/content/vocabularies"
    element={<Vocabularies />}
  />,
  <Route
    key="create-vocabulary"
    path="/content/vocabularies/create"
    element={<CreateVocabulary />}
  />,
  <Route
    key="text-leveler"
    path="/content/text-leveler"
    element={<TextLeveler />}
  />,
  <Route
    key="create-text-leveler"
    path="/content/text-leveler/create"
    element={<CreateTextLeveler />}
  />,
  <Route key="images" path="/content/images" element={<ImageGenerator />} />,
  <Route
    key="interactive-materials"
    path="/content/interactive-materials"
    element={<InteractiveMaterials />}
  />,
  <Route
    key="create-interactive-material"
    path="/content/interactive-materials/create"
    element={<CreateInteractiveMaterial />}
  />,
  <Route
    key="single-interactive-material"
    path="/content/interactive-materials/:id"
    element={<SingleInteractiveMaterials />}
  />,
  <Route
    key="edit-interactive-material"
    path="/content/interactive-materials/:id/edit"
    element={<EditInteractiveMaterial />}
  />,
  <Route
    key="advanced-edit-interactive-material"
    path="/content/interactive-materials/:id/advanced-edit"
    element={<AdvancedEditInteractiveMaterial />}
  />,
  <Route
    key="clone-interactive-material"
    path="/material/:id"
    element={<CloneInteractiveMaterial />}
  />,
  <Route
    key="student-answers"
    path="/content/interactive-materials/:id/review/student/:studentId"
    element={<StudentAnswers />}
  />,
  <Route key="mindmaps" path="/content/mindmaps" element={<Mindmaps />} />,
  <Route
    key="mindmap-view"
    path="/content/mindmaps/:id"
    element={<MindMapView />}
  />,
  <Route
    key="exit-tickets"
    path="/content/exit-tickets"
    element={<ExitTickets />}
  />,
  <Route
    key="create-exit-ticket"
    path="/content/exit-tickets/create"
    element={<CreateExitTicket />}
  />,
  <Route
    key="homework-ideas"
    path="/content/homework-ideas"
    element={<HomeworkIdeas />}
  />,
  <Route
    key="create-homework-idea"
    path="/content/homework-ideas/create"
    element={<CreateHomeworkIdea />}
  />,
  <Route
    key="choice-boards"
    path="/content/choice-boards"
    element={<ChoiceBoards />}
  />,
  <Route
    key="create-create-vocabulary"
    path="/content/choice-boards/create"
    element={<CreateChoiceBoards />}
  />,
  <Route
    key="ai-resistant-homework-ideas"
    path="/content/ai-resistant-homework-ideas"
    element={<AiResistantHomeworkIdeas />}
  />,
  <Route
    key="create-ai-resistant-homework-ideas"
    path="/content/ai-resistant-homework-ideas/create"
    element={<CreateAiResistantHomeworkIdeas />}
  />,
  <Route
    key="ai-assignment-designer"
    path="/content/ai-assignment-designer"
    element={<AiAssignmentDesigner />}
  />,
  <Route
    key="create-ai-assignment-designer"
    path="/content/ai-assignment-designer/create"
    element={<CreateAiAssignmentDesigner />}
  />,
  <Route
    key="essential-questions"
    path="/content/essential-questions"
    element={<EssentialQuestions />}
  />,
  <Route
    key="create-essential-questions"
    path="/content/essential-questions/create"
    element={<CreateEssentialQuestions />}
  />,
  <Route
    key="blooms-taxonomy-activities"
    path="/content/blooms-taxonomy-activities"
    element={<BloomsTaxonomyActivity />}
  />,
  <Route
    key="create-blooms-taxonomy-activity"
    path="/content/blooms-taxonomy-activities/create"
    element={<CreateBloomsTaxonomyActivity />}
  />,
  <Route
    key="formative-assessment"
    path="/content/formative-assessment"
    element={<FormativeAssessment />}
  />,
  <Route
    key="create-formative-assessment"
    path="/content/formative-assessment/create"
    element={<CreateFormativeAssessment />}
  />,
  <Route
    key="performance-tasks"
    path="/content/performance-tasks"
    element={<PerformanceTasks />}
  />,
  <Route
    key="create-performance-tasks"
    path="/content/performance-tasks/create"
    element={<CreatePerformanceTask />}
  />,
  <Route
    key="project-based-learning"
    path="/content/project-based-learning"
    element={<ProjectBasedLearning />}
  />,
  <Route
    key="create-project-based-learning"
    path="/content/project-based-learning/create"
    element={<CreateProjectBasedLearning />}
  />,
  <Route
    key="transfer-activity"
    path="/content/transfer-activity"
    element={<TransferActivity />}
  />,
  <Route
    key="create-transfer-activity"
    path="/content/transfer-activity/create"
    element={<CreateTransferActivity />}
  />,
  <Route key="rubric" path="/content/rubric" element={<Rubric />} />,
  <Route
    key="create-rubric"
    path="/content/rubric/create"
    element={<CreateRubric />}
  />,
  <Route
    key="collaborative"
    path="/content/collaborative"
    element={<Collaborative />}
  />,
  <Route
    key="create-collaborative"
    path="/content/collaborative/create"
    element={<CreateCollaborative />}
  />,
  <Route
    key="classroom-management"
    path="/content/classroom-management"
    element={<ClassroomManagement />}
  />,
  <Route
    key="create-classroom-management"
    path="/content/classroom-management/create"
    element={<CreateClassroomManagement />}
  />,
  <Route
    key="ai-supported-tasks"
    path="/content/ai-supported-tasks"
    element={<AiSupportedTasks />}
  />,
  <Route
    key="create-ai-supported-task"
    path="/content/ai-supported-tasks/create"
    element={<CreateAiSupportedTask />}
  />,
  <Route
    key="ai-assessment-scale"
    path="/content/ai-assessment-scale"
    element={<AiAssessmentScale />}
  />,
  <Route
    key="create-ai-assessment-scale"
    path="/content/ai-assessment-scale/create"
    element={<CreateAiAssessmentScale />}
  />,
  <Route
    key="video-avatar-generator"
    path="/content/video-avatar-generator"
    element={<HeygenVideoGenerator />}
  />,
  <Route
    key="create-video-avatar-generator"
    path="/content/video-avatar-generator/create"
    element={<CreateHeygenVideoGenerator />}
  />,
  <Route
    key="article-generator"
    path="/content/article-generator"
    element={<ArticleGenerator />}
  />,
  <Route
    key="create-article"
    path="/content/article-generator/create"
    element={<CreateArticle />}
  />,
  <Route
    key="article-view"
    path="/content/article-generator/article/:id"
    element={<ArticleView />}
  />,
  <Route
    key="pronunciation-assessment"
    path="/content/pronunciation-assessment"
    element={<PronunciationAssessment />}
  />,
  <Route
    key="create-pronunciation-assessment"
    path="/content/pronunciation-assessment/create"
    element={<CreatePronunciationAssessment />}
  />,
  <Route
    key="pronunciation-assessment-detail"
    path="/content/pronunciation-assessment/:id"
    element={<PronunciationAssessmentDetail />}
  />,
  <Route
    key="visual-matching"
    path="/content/visual-matching"
    element={<VisualMatching />}
  />,
  <Route
    key="create-visual-matching"
    path="/content/visual-matching/create"
    element={<CreateVisualMatching />}
  />,
  <Route
    key="visual-matching-detail"
    path="/content/visual-matching/:id"
    element={<VisualMatchingDetail />}
  />,
  <Route
    key="spoken-dialogue"
    path="/content/spoken-dialogue"
    element={<SpokenDialogue />}
  />,
  <Route
    key="create-spoken-dialogue"
    path="/content/spoken-dialogue/create"
    element={<CreateSpokenDialogue />}
  />,
  <Route
    key="detail-spoken-dialogue"
    path="/content/spoken-dialogue/:id"
    element={<DetailSpokenDialogue />}
  />,
  <Route
    key="conversation-practice"
    path="/content/spoken-dialogue/:id/practice"
    element={<ConversationPractice />}
  />,
];
